import React from 'react';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// HELP
import LeftSection from './help/LeftSection';

// STYLES
import { Container } from './styles';

const welcomeImg = getS3ImageUrl('/partner-tv/channel-images.png');
const welcomeImg2x = getS3ImageUrl('/partner-tv/channel-images-2x.png');

const Welcome = () => {
  const { partner } = useSelector(({ partner: partnerStore }) => ({
    partner: partnerStore.data,
  }));
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  const textOverwrites = partner.text_overwrites || {};
  const mainImage = textOverwrites.tv_welcome || welcomeImg;
  const mobImage = textOverwrites.tv_welcome_mob || mainImage;
  const img = downXs ? mobImage : mainImage;
  const srcSet = textOverwrites.tv_welcome ? {} : { srcSet: `${welcomeImg2x} 2x` };

  return (
    <Container className="welcome">
      <div className="page-content welcome__content">
        <Grid container spacing={4} justifyContent="space-between" alignItems="center">
          <Grid item xs={12} sm={7} md={8}>
            <LeftSection />
          </Grid>
          <Grid item xs={12} sm={5} md={4}>
            <div className="welcome__img">
              <img src={img} {...srcSet} alt="welcome" />
            </div>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

export default React.memo(Welcome);
